import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const GrabModeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Move/drag arrows - 4 direction arrows */}
      {/* Center */}
      <circle cx="12" cy="12" r="2" fill={color} />
      {/* Up arrow */}
      <path d="M12 3v6M9 6l3-3 3 3" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Down arrow */}
      <path d="M12 21v-6M9 18l3 3 3-3" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Left arrow */}
      <path d="M3 12h6M6 9l-3 3 3 3" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Right arrow */}
      <path d="M21 12h-6M18 9l3 3-3 3" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </BaseIcon>
  ),
);

GrabModeIcon.displayName = 'GrabModeIcon';
